import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import Spinner from '../../../../components/Loaders/Spinner';

import { rejectPayment } from '../../../../services/endpoints/payments';
import { getErrorMessage } from '../../../../utils/helper';
import AlertComponent from '../../../../components/Alert';

const RejectModal = ({ open, item, onHide, onSubmit }) => {
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const onSubmitForm = async () => {
    try {
      setLoading(true)
      await rejectPayment(item.id)
      onSubmit({}, 'reject')
    } catch (error) {
      setLoading(false);
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
    }
  };

  return (
    <Modal show={open} bsSize="sm" onHide={onHide} backdrop="static" className={classNames('modal__confirm')}>
      <Modal.Body>
        {error ? <AlertComponent type="danger" text={error} /> : null }
        <div className="modal__confirm-title">
          <div className="text-center">
            Reject
            <div>
              (Payment ID:
              {item?.id}
              )
            </div>
          </div>
        </div>
        <div className="modal__confirm-description">
          <div className="text-center">
            Are you sure you want to change the payment status to
            {' '}
            <b>Expired</b>
            ?
          </div>
        </div>
        <div className="modal__confirm-actions">
          <Button bsStyle="danger" onClick={onSubmitForm} disabled={isLoading} type="button">
            {isLoading && <Spinner />}
            <span>Reject</span>
          </Button>
          <Button onClick={onHide}>Cancel</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

RejectModal.propTypes = {
  item: PropTypes.object,
  open: PropTypes.bool,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default RejectModal;
